import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { IntroSection } from './edm-consumables/IntroSection';
import { CertifiedWireSection } from './edm-consumables/CertifiedWireSection';
import { WireTypesSection } from './edm-consumables/WireTypesSection';
import { CatalogSection } from './edm-consumables/CatalogSection';
import { SmartWireSection } from './edm-consumables/SmartWireSection';
import { RequestQuoteSection } from './edm-consumables/RequestQuoteSection';
export function EDMConsumablesPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2096">
      <SeoBar data-id="element-2097" />
      <Header data-id="element-2098" />
      <main className="flex-grow" data-id="element-2099">
        <div className="w-full bg-gray-50 pb-20" data-id="element-2100">
          <IntroSection data-id="element-2101" />
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16" data-id="element-2102">
            <CertifiedWireSection data-id="element-2103" />
            <WireTypesSection data-id="element-2104" />
          </div>
          <CatalogSection data-id="element-2105" />
          <SmartWireSection data-id="element-2106" />
          <RequestQuoteSection data-id="element-2107" />
        </div>
      </main>
      <Footer data-id="element-2108" />
    </div>;
}